var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "schedule-stat-v3",
    },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-badge-group" }, [
          _c("span", { staticClass: "live-indicator" }, [
            _c("span", { staticClass: "pulse-dot" }),
            _vm._v(
              "\n      Đã đăng: " +
                _vm._s(_vm.headerPublishedLabel) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "filter-control-bar" }, [
        _c("div", { staticClass: "filter-left" }, [
          _c(
            "div",
            { staticClass: "filter-chip" },
            [
              _vm._m(1),
              _c("el-date-picker", {
                staticClass: "week-picker",
                attrs: {
                  type: "week",
                  size: "small",
                  format: "Tuần WW (yyyy)",
                  placeholder: "Chọn tuần xem",
                  clearable: false,
                },
                on: { change: _vm.handleWeekChange },
                model: {
                  value: _vm.selectedWeekDate,
                  callback: function ($$v) {
                    _vm.selectedWeekDate = $$v
                  },
                  expression: "selectedWeekDate",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "week-nav-btn-group" }, [
            _c(
              "button",
              {
                staticClass: "nav-arrow-btn",
                attrs: { title: "Tuần trước" },
                on: { click: _vm.prevWeek },
              },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            ),
            _c(
              "button",
              {
                staticClass: "nav-current-btn",
                on: { click: _vm.currentWeek },
              },
              [_vm._v("\n          Tuần này\n        ")]
            ),
            _c(
              "button",
              {
                staticClass: "nav-arrow-btn",
                attrs: { title: "Tuần sau" },
                on: { click: _vm.nextWeek },
              },
              [_c("i", { staticClass: "el-icon-arrow-right" })]
            ),
          ]),
          _c("div", { staticClass: "week-range-tag" }, [
            _c("i", { staticClass: "el-icon-calendar" }),
            _c("span", [_vm._v(_vm._s(_vm.weekRangeLabel))]),
          ]),
          _c(
            "div",
            { staticClass: "filter-chip" },
            [
              _vm._m(2),
              _c(
                "el-select",
                {
                  staticClass: "grade-select",
                  attrs: { size: "small", placeholder: "Tất cả các khối" },
                  on: { change: _vm.handleGradeChange },
                  model: {
                    value: _vm.selectedGrade,
                    callback: function ($$v) {
                      _vm.selectedGrade = $$v
                    },
                    expression: "selectedGrade",
                  },
                },
                _vm._l(_vm.gradeOptions, function (g) {
                  return _c("el-option", {
                    key: g.value,
                    attrs: { label: g.label, value: g.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.errorMessage
        ? _c("el-alert", {
            staticClass: "schedule-error",
            attrs: {
              title: "Không tải được thống kê thời khóa biểu",
              description: _vm.errorMessage,
              type: "error",
              "show-icon": "",
              closable: false,
            },
          })
        : _vm._e(),
      _vm.hasData
        ? _c(
            "div",
            [
              _c("div", { staticClass: "schedule-kpi-grid" }, [
                _c("div", { staticClass: "schedule-kpi-card border-indigo" }, [
                  _vm._m(3),
                  _c("div", { staticClass: "kpi-details" }, [
                    _c("span", { staticClass: "kpi-name" }, [
                      _vm._v("Tổng số lớp học"),
                    ]),
                    _c("div", { staticClass: "kpi-number text-indigo" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.hasData ? _vm.totalClassesCount : "—") +
                          " "
                      ),
                      _c("span", { staticClass: "kpi-unit" }, [_vm._v("lớp")]),
                    ]),
                    _c("div", { staticClass: "kpi-hint" }, [
                      _vm._v(_vm._s(_vm.selectedGradeLabel)),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "schedule-kpi-card border-emerald interactive-card",
                    on: {
                      click: function ($event) {
                        return _vm.openScheduleDialog("published")
                      },
                    },
                  },
                  [
                    _vm._m(4),
                    _c("div", { staticClass: "kpi-details" }, [
                      _vm._m(5),
                      _c("div", { staticClass: "kpi-number text-emerald" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.hasData ? _vm.publishedCount : "—") +
                            " "
                        ),
                        _c("span", { staticClass: "kpi-unit" }, [
                          _vm._v("lớp"),
                        ]),
                      ]),
                      _c("div", { staticClass: "kpi-hint text-emerald" }, [
                        _c("i", { staticClass: "el-icon-check" }),
                        _vm._v(
                          " Đạt " +
                            _vm._s(_vm.publishRate) +
                            "% " +
                            _vm._s(_vm.selectedGradeLabel) +
                            "\n        "
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "schedule-kpi-card border-rose interactive-card",
                    on: {
                      click: function ($event) {
                        return _vm.openScheduleDialog("unpublished")
                      },
                    },
                  },
                  [
                    _vm._m(6),
                    _c("div", { staticClass: "kpi-details" }, [
                      _vm._m(7),
                      _c("div", { staticClass: "kpi-number text-rose" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.hasData ? _vm.unpublishedCount : "—") +
                            " "
                        ),
                        _c("span", { staticClass: "kpi-unit" }, [
                          _vm._v("lớp"),
                        ]),
                      ]),
                      _c("div", { staticClass: "kpi-hint text-rose" }, [
                        _c("i", { staticClass: "el-icon-bell" }),
                        _vm._v(
                          " Còn " +
                            _vm._s(_vm.unpublishRate) +
                            "% cần nộp\n        "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _c(
                "el-row",
                { staticClass: "charts-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 15 } }, [
                    _c("div", { staticClass: "chart-card h-100" }, [
                      _c("div", { staticClass: "chart-card-head" }, [
                        _c("div", [
                          _c("h3", { staticClass: "chart-title" }, [
                            _vm._v("Tình Hình Đăng Thời Khóa Biểu Theo Khối"),
                          ]),
                          _c("p", { staticClass: "chart-subtitle" }, [
                            _vm._v(
                              _vm._s(_vm.weekRangeLabel) +
                                " • So sánh số lớp đã đăng và chưa đăng"
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "chart-legend-chips" }, [
                          _c("span", { staticClass: "legend-dot-item" }, [
                            _c("span", { staticClass: "chip-color chip-pub" }),
                            _vm._v(" Đã đăng"),
                          ]),
                          _c("span", { staticClass: "legend-dot-item" }, [
                            _c("span", {
                              staticClass: "chip-color chip-unpub",
                            }),
                            _vm._v(" Chưa đăng"),
                          ]),
                        ]),
                      ]),
                      _vm.gradeStats.length
                        ? _c("div", { staticClass: "grade-chart-scroll" }, [
                            _c("div", {
                              ref: "chartGradeSchedule",
                              staticClass: "grade-chart-canvas",
                              style: {
                                width: `${_vm.gradeStats.length * 118}px`,
                              },
                            }),
                          ])
                        : _c("p", { staticClass: "grade-chart-empty" }, [
                            _vm._v("Không có lớp trong phạm vi đang chọn."),
                          ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { xs: 24, sm: 24, md: 10, lg: 9 } }, [
                    _c("div", { staticClass: "chart-card h-100" }, [
                      _c("div", { staticClass: "chart-card-head" }, [
                        _c("div", [
                          _c("h3", { staticClass: "chart-title" }, [
                            _vm._v("Tỷ Lệ Lớp Đã Đăng Kế Hoạch Tuần"),
                          ]),
                          _c("p", { staticClass: "chart-subtitle" }, [
                            _vm._v(
                              "Tiến độ hoàn thành đăng kế hoạch thời khóa biểu"
                            ),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            class: [
                              "tag-pill",
                              _vm.publishRate >= 90
                                ? "tag-pill--emerald"
                                : "tag-pill--amber",
                            ],
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.publishRate >= 90
                                    ? "Hoàn thành tốt"
                                    : "Cần đôn đốc"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", {
                        ref: "chartCoverageGauge",
                        staticClass: "chart-container-gauge",
                      }),
                      _c(
                        "div",
                        { staticClass: "gauge-action-footer" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "quick-open-btn",
                              attrs: {
                                type: "success",
                                size: "small",
                                icon: "el-icon-circle-check",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openScheduleDialog("published")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Danh sách đã đăng (" +
                                  _vm._s(
                                    _vm.hasData ? _vm.publishedCount : "—"
                                  ) +
                                  ")\n          "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "quick-open-btn",
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-warning-outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openScheduleDialog("unpublished")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Danh sách chưa đăng (" +
                                  _vm._s(
                                    _vm.hasData ? _vm.unpublishedCount : "—"
                                  ) +
                                  ")\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "60%",
            top: "7vh",
            "custom-class": "modern-schedule-dialog",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-custom-header",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "div",
                {
                  staticClass: "header-icon-box",
                  class:
                    _vm.activeTab === "published" ? "box-emerald" : "box-rose",
                },
                [
                  _c("i", {
                    class:
                      _vm.activeTab === "published"
                        ? "el-icon-circle-check"
                        : "el-icon-warning-outline",
                  }),
                ]
              ),
              _c("div", [
                _c("h3", { staticClass: "dialog-heading" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.activeTab === "published"
                          ? "Danh Sách Các Lớp Đã Đăng Thời Khóa Biểu"
                          : "Danh Sách Các Lớp Chưa Đăng Thời Khóa Biểu"
                      ) +
                      "\n        "
                  ),
                ]),
                _c("p", { staticClass: "dialog-subheading" }, [
                  _c("i", { staticClass: "el-icon-calendar" }),
                  _vm._v(" " + _vm._s(_vm.weekRangeLabel) + "  • \n          "),
                  _c("i", { staticClass: "el-icon-office-building" }),
                  _vm._v(" Hệ thống Trường Mầm Non OneKids\n        "),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "dialog-tab-bar" }, [
            _c(
              "button",
              {
                class: [
                  "dialog-tab-btn",
                  { active: _vm.activeTab === "published" },
                ],
                on: {
                  click: function ($event) {
                    _vm.activeTab = "published"
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-circle-check" }),
                _c("span", [
                  _vm._v(
                    "Lớp đã đăng (" + _vm._s(_vm.publishedList.length) + ")"
                  ),
                ]),
              ]
            ),
            _c(
              "button",
              {
                class: [
                  "dialog-tab-btn",
                  "btn-danger-tab",
                  { active: _vm.activeTab === "unpublished" },
                ],
                on: {
                  click: function ($event) {
                    _vm.activeTab = "unpublished"
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _c("span", [
                  _vm._v(
                    "Lớp chưa đăng (" + _vm._s(_vm.unpublishedList.length) + ")"
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "dialog-search-wrap" },
              [
                _c("el-input", {
                  staticClass: "dialog-search-input",
                  attrs: {
                    size: "small",
                    placeholder: "Tìm theo tên lớp hoặc khối...",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                  },
                  model: {
                    value: _vm.searchQuery,
                    callback: function ($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.activeTab === "published"
            ? _c(
                "div",
                { staticClass: "dialog-table-container" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "modern-schedule-table",
                      attrs: {
                        data: _vm.filteredPublishedList,
                        stripe: "",
                        border: "",
                        size: "small",
                        "empty-text":
                          "Chưa có lớp nào đăng thời khóa biểu cho tuần này",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tên Lớp", "min-width": "160" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "class-title-cell" },
                                    [
                                      _c(
                                        "strong",
                                        { staticClass: "text-indigo" },
                                        [_vm._v(_vm._s(scope.row.className))]
                                      ),
                                      _c("span", { staticClass: "sub-grade" }, [
                                        _vm._v(_vm._s(scope.row.gradeName)),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2816445436
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Trạng thái duyệt",
                          "min-width": "140",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.approvalLabel(
                                          scope.row.approvalStatus
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          483187118
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tệp kế hoạch", "min-width": "170" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.attachments,
                                  function (file) {
                                    return _c(
                                      "el-button",
                                      {
                                        key: file.attachmentId,
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadAttachment(file)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(file.fileName || "Tải tệp") +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2437573856
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Cập nhật lần cuối",
                          "min-width": "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDateTime(scope.row.updatedAt)
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3678721310
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "dialog-table-container" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "modern-schedule-table",
                      attrs: {
                        data: _vm.filteredUnpublishedList,
                        stripe: "",
                        border: "",
                        size: "small",
                        "empty-text":
                          "Tuyệt vời! Tất cả các lớp đã hoàn thành đăng thời khóa biểu",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tên Lớp", "min-width": "160" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "class-title-cell" }, [
                                  _c("strong", { staticClass: "text-rose" }, [
                                    _vm._v(_vm._s(scope.row.className)),
                                  ]),
                                  _c("span", { staticClass: "sub-grade" }, [
                                    _vm._v(_vm._s(scope.row.gradeName)),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Trạng thái",
                          "min-width": "130",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.published
                                      ? "Đã đăng"
                                      : "Chưa đăng"
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-time" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Thời Khóa Biểu & Tiến Độ Đăng Kế Hoạch"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v(
            "\n          Theo dõi tiến độ đăng kế hoạch thời khóa biểu tuần của các lớp\n        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Chọn tuần:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
      _vm._v(" Khối:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-indigo-soft text-indigo" },
      [_c("i", { staticClass: "el-icon-s-home" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-soft text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Số lớp đã đăng")]),
      _c("span", { staticClass: "click-hint-badge text-emerald" }, [
        _vm._v("Xem chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-rose-soft text-rose" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-title-row" }, [
      _c("span", { staticClass: "kpi-name" }, [_vm._v("Số lớp chưa đăng")]),
      _c("span", { staticClass: "click-hint-badge text-rose" }, [
        _vm._v("Xem chi tiết "),
        _c("i", { staticClass: "el-icon-arrow-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }